import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./licenciamiento-software.css";
import software1 from "./img-domotic/licenciamiento_de_software.png";
import software2 from "./img-domotic/licenciamiento_de_software2.png";
import software3 from "./img-domotic/licenciamiento_de_software3.png";

import microsoft from "./img-domotic/licenciamiento_de_software3.png";
import oracle from "./img-domotic/licenciamiento_de_software3.png";
import sap from "./img-domotic/licenciamiento_de_software3.png";
import salesforce from "./img-domotic/licenciamiento_de_software3.png";

const SpecializedSoftware = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Software Especializado
  const imagenesGaleria = [
    { src: software1, alt: "Desarrollo de software a medida", caption: "Soluciones personalizadas para su negocio" },
    { src: software2, alt: "Implementación de sistemas ERP", caption: "Integración de procesos empresariales" },
    { src: software3, alt: "Plataformas en la nube", caption: "Infraestructura escalable y segura" }
  ];

  const servicios = [
    {
      icon: "💻",
      titulo: "Desarrollo a Medida",
      descripcion: "Creación de aplicaciones empresariales adaptadas a sus procesos específicos.",
      features: ["Análisis de requerimientos", "Metodologías ágiles", "Pruebas de calidad"]
    },
    {
      icon: "📊",
      titulo: "Business Intelligence",
      descripcion: "Plataformas de análisis de datos para la toma de decisiones estratégicas.",
      features: ["Dashboards interactivos", "Reportes automatizados", "Predictive Analytics"]
    },
    {
      icon: "🔄",
      titulo: "Integración de Sistemas",
      descripcion: "Conectamos sus aplicaciones existentes para un flujo de datos unificado.",
      features: ["APIs personalizadas", "Middleware especializado", "ETL avanzado"]
    },
    {
      icon: "☁️",
      titulo: "Soluciones en la Nube",
      descripcion: "Migración, implementación y gestión de plataformas cloud enterprise.",
      features: ["Arquitectura multi-cloud", "Seguridad certificada", "Escalabilidad automática"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Verticales Industriales",
      items: [
        "Software para healthcare",
        "Soluciones logísticas",
        "Sistemas para retail",
        "Plataformas educativas"
      ]
    },
    {
      categoria: "Tecnologías",
      items: [
        "Inteligencia Artificial",
        "Machine Learning",
        "Blockchain",
        "IoT Platforms"
      ]
    },
    {
      categoria: "Modelos de Implementación",
      items: [
        "SaaS (Software as a Service)",
        "On-Premise Solutions",
        "Hybrid Deployments",
        "Managed Services"
      ]
    }
  ];

  const marcas = [
    { nombre: "Microsoft", logo: microsoft },
    { nombre: "Oracle", logo: oracle },
    { nombre: "SAP", logo: sap },
    { nombre: "Salesforce", logo: salesforce },
    { nombre: "IBM", logo: "/marcas/ibm.png" },
    { nombre: "ServiceNow", logo: "/marcas/servicenow.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.software-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="software-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="software-hero">
        <div className="software-hero-content">
          <h1 className="software-hero-title">Servicios y Software Especializado</h1>
          <p className="software-hero-subtitle">
            Soluciones tecnológicas para transformar su negocio
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="software-gallery software-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="software-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="software-gallery-img"
            />
            <div className="software-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

        {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Software Especializado</h2>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">Software Especializado</h3>
          <p className="ryn-feature-desc">Diseñamos Software a medida para soluciones especificas </p>
          <ul className="ryn-feature-list">
            <li>Sistema de  gestión y control de asistencia: versión  cloud y de escritorio,</li>
            <li>Software Microsoft, Office para Educación</li>
            <li>Softwares expertos para automatización de proceso y ciberseguridad</li>
          </ul>
        </div>
      </div>
      

    </div>
  </div>
</section>  




 
    </div>
  );
};

export default SpecializedSoftware;